import {Alert} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface RetryAlertProps {
  description: string;
  onRetry?: () => void;
}

/** An error alert for something that failed to load, with a "try again" action when it can be retried. */
export const RetryAlert: FC<RetryAlertProps> = ({description, onRetry}) => {
  const {t} = useTranslation('common');

  return (
    <Alert
      variant="error"
      description={description}
      actions={onRetry ? [{label: t('errorState.retry'), onClick: onRetry}] : undefined}
    />
  );
};
